import React, { useMemo } from 'react';
import styles from '@/styles/components/ui/SearchInput.module.css';

export interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  inputSize?: 'sm' | 'md';
  className?: string;
  ariaLabel?: string;
  showClear?: boolean;
  onClear?: () => void;
}

const SearchIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img
    src={'/icons/model gallery/search_result.svg'}
    alt="Search"
    className={className}
    width={16}
    height={16}
    loading="eager"
    style={{ display: 'block' }}
  />
);

const ClearIcon: React.FC = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search item',
  inputSize = 'md',
  className,
  ariaLabel,
  showClear = false,
  onClear,
  id,
  ...inputProps
}) => {
  const containerClass = useMemo(() => {
    const base = styles.container;
    return `${base} ${inputSize === 'sm' ? styles.sm : styles.md} ${className || ''}`;
  }, [className, inputSize]);

  return (
    <div className={containerClass}>
      <div className={styles.iconWrapper}>
        <SearchIcon />
      </div>
      <input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className={styles.input}
        role="searchbox"
        autoComplete="off"
        spellCheck={false}
        {...inputProps}
      />
      {showClear && value && (
        <button
          type="button"
          className={styles.clearButton}
          aria-label="Clear search"
          onClick={() => onClear && onClear()}
        >
          <ClearIcon />
        </button>
      )}
    </div>
  );
};

export default SearchInput;

